import React, { useState } from "react";
import PropTypes from "prop-types";

const FakeSelect = ({
  title,
  icon,
  children,
  className,
  valueKey,
  onChange,
}) => {
  const [value, setValue] = useState("");

  const onSelectChange = (event) => {
    const newValue = valueKey
      ? event.target.querySelector("option:checked").dataset[valueKey]
      : event.value;
    setValue(newValue);

    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className={`fake-select ${className}`}>
      <select onChange={onSelectChange}>{children}</select>
      <span className="btn is-outline">
        <svg className="btn__icon is-prefix" width={icon[1]} height={icon[2]}>
          <use xlinkHref={`#${icon[0]}`} width={icon[1]} height={icon[2]} />
        </svg>
        <span className="btn__text">{value || title}</span>
      </span>
    </div>
  );
};

FakeSelect.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  icon: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  valueKey: PropTypes.string,
  className: PropTypes.string,
};

FakeSelect.defaultProps = {
  icon: "",
  valueKey: "",
  className: "",
};

export default FakeSelect;
